import {Constants} from "./Constants";
import {StringUtility} from "./StringUtility";
import {DateUtility} from "./DateUtility";
import _ from "lodash";

export let SubscriptionDataUtility = {
    getSubscriptionTotalDisplay: function (subscription) {
        let totalDisplay = StringUtility.stringNumberToDisplayCurrency('' + subscription.invoice_total)
        if (subscription.subscription_billing_period) {
            totalDisplay += `/${subscription.subscription_billing_period.ext_stripe_value}`
        }
        return totalDisplay;
    },

    getSubscriptionLinesDisplay: function (subscription, withoutOn) {
        let linesDisplay = '';
        if (subscription.subscription_invoice_lines.length > 0) {
            if (!withoutOn) {
                linesDisplay += ' on ';
            }
            let productNames = [];
            for (let i = 0; i < Math.min(3, subscription.subscription_invoice_lines.length); i++) {
                let subscriptionInvoiceLine = subscription.subscription_invoice_lines[i];
                if (subscriptionInvoiceLine.name) {
                    productNames.push(subscriptionInvoiceLine.name)
                } else {
                    productNames.push(subscriptionInvoiceLine.fp_service.name)
                }
            }
            linesDisplay += productNames.join(', ')
            if (subscription.subscription_invoice_lines.length > 3) {
                linesDisplay += ', etc.'
            }
        }
        return linesDisplay;
    },

    fpInvoiceToSubscriptionFormData: function (fpInvoice, invoiceLines) {
        return {
            ext_fp_invoice_id: fpInvoice.id,
            ext_fp_invoice_number: fpInvoice.invoicenumber,
            description: fpInvoice.description || '',
            invoiceLines: invoiceLines.map(function (invoiceLine) {
                invoiceLine.invoice_line_type_id = Constants.qboInvoiceLineTypes.fpService
                return invoiceLine
            })
        }
    },

    subscriptionForForm: function (subscription) {
        let formattedSubscription = _.clone(subscription)

        formattedSubscription.invoiceLines = [];
        for (let i = 0; i < subscription.subscription_invoice_lines.length; i++) {
            let line = subscription.subscription_invoice_lines[i];
            line.amount = '' + line.amount
            if (line.fp_service) {
                line.invoice_line_type_id = Constants.qboInvoiceLineTypes.fpService
                line.ext_fp_service_id = line.fp_service.ext_fp_service_id
                line.fp_service_type_name = line.fp_service.fp_service_type?.name;
            } else {
                line.invoice_line_type_id = Constants.qboInvoiceLineTypes.custom
                line.fp_service_type_name = line.fp_service_type?.name;
            }

            formattedSubscription.invoiceLines.push(line)
        }

        return formattedSubscription;
    },

    getSubscriptionInvoiceTitle: function (subscription, invoice) {
        let title = '';
        if (
            subscription.subscription_billing_period?.name ===
            Constants.subscriptionBillingPeriodOptionsHash.yearly.label
        ) {
            let dueYear = DateUtility.dbDateToMoment(invoice.due_date).format('YYYY')
            title = `Invoice #${invoice.sequence_number_in_subscription} - ${dueYear}`
        } else {
            let dueDisplay = DateUtility.dbDateToMoment(invoice.due_date).format('MMM YYYY')
            title = `Invoice #${invoice.sequence_number_in_subscription} - ${dueDisplay}`
        }
        return title;
    }
}
